import type { CityConfig } from "../city-template/types";

export const clarksburgConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Clarksburg",
  state: "West Virginia",
  stateAbbr: "WV",
  slug: "clarksburg",
  route: "/clarksburg",
  title: "Emergency Passport Clarksburg, WV — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Clarksburg, WV — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Harrison County, FBI CJIS, and North Central WV via Pittsburgh and Morgantown airports.",
  h1: "Emergency & Expedited Passport Services in Clarksburg, WV",
  heroSubtitle: "Pittsburgh flight to Frankfurt in 10 days? FBI CJIS contractor deployment to London? Fairmont State study abroad to Barcelona? We help Clarksburg residents — from downtown professionals to Bridgeport families to FBI CJIS employees and contractors — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Clarksburg%20West%20Virginia%20historic%20downtown%20nestled%20in%20the%20rolling%20Appalachian%20foothills%20of%20Harrison%20County%2C%20historic%20brick%20commercial%20buildings%20along%20Main%20Street%20with%20the%20Harrison%20County%20Courthouse%20tower%20visible%2C%20tree-covered%20hills%20surrounding%20the%20small%20city%2C%20warm%20afternoon%20sunlight%2C%20North%20Central%20West%20Virginia%20community%20atmosphere%20with%20bridges%20and%20green%20valleys&width=1800&height=700&seq=clarksburg-hero-2026&orientation=landscape",
  heroImageAlt: "Clarksburg West Virginia historic downtown in Harrison County Appalachian foothills",
  geoPosition: "39.2806;-80.3445",
  geoPlacename: "Clarksburg, West Virginia",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 350 miles from Clarksburg — appointments required, typically booked 2+ weeks out. Pittsburgh is the practical airport but has limited agency hours.",
  },
  nearbyCitiesZips: [
    { name: "Clarksburg", zips: "26301, 26302" },
    { name: "Bridgeport", zips: "26330" },
    { name: "Nutter Fort", zips: "26301" },
    { name: "Stonewood", zips: "26301" },
    { name: "Anmoore", zips: "26323" },
    { name: "Shinnston", zips: "26431" },
    { name: "Salem", zips: "26426" },
    { name: "Lost Creek", zips: "26385" },
    { name: "Fairmont", zips: "26554, 26555" },
    { name: "Morgantown", zips: "26505, 26506" },
  ],
  benefits: [
    { icon: "ri-flight-takeoff-line", title: "I-79 Corridor — Pittsburgh & Morgantown Access", desc: "Clarksburg sits directly on I-79, with Pittsburgh International Airport (PIT) 105 miles north and Morgantown Municipal Airport (MGW) 35 miles north. Direct international flights from PIT and regional connections from MGW. We build airport-specific timelines for every traveler." },
    { icon: "ri-shield-check-line", title: "FBI CJIS — Federal Law Enforcement Hub", desc: "Clarksburg is home to the FBI's Criminal Justice Information Services (CJIS) Division — the largest FBI division outside DC, employing thousands of federal agents, analysts, and contractors. International travel for FBI training, interagency meetings, and contractor deployments is common and often short-notice." },
    { icon: "ri-building-2-line", title: "North Central WV Economic Center", desc: "As the county seat of Harrison County, Clarksburg anchors a regional economy that includes the FBI CJIS complex, United Hospital Center, Fairmont State University proximity, and the North Central West Virginia Airport (CKB). International business and healthcare travel are steady year-round." },
    { icon: "ri-graduation-cap-line", title: "FSU & College Proximity", desc: "Fairmont State University is just 18 miles north — many Clarksburg-area students attend FSU and need passports for study abroad, mission trips, and spring break international travel. We provide student-specific guidance." },
  ],
  testimonials: [
    {
      name: "Thomas K.",
      location: "Downtown Clarksburg",
      rating: 5,
      text: "FBI CJIS sent me to an interagency cybersecurity conference in London with 9 days notice. My passport was expired and clearance travel authorization was already approved. They handled everything — new passport in 6 days, made the deployment.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Rachel S.",
      location: "Bridgeport",
      rating: 5,
      text: "United Hospital Center cardiology conference in Barcelona. 16 days notice and my passport was expiring. The remote process worked perfectly — no need to drive anywhere beyond the Bridgeport post office for the acceptance visit.",
      service: "Passport Renewal — Urgent",
    },
    {
      name: "The Johnson Family",
      location: "Nutter Fort",
      rating: 5,
      text: "Family trip to Cancun via Pittsburgh — three passports needed work. One renewal, one new child passport, one name change. All three handled simultaneously and all arrived in 10 days. Couldn't believe how smooth it was.",
      service: "Multiple Passport Services",
    },
    {
      name: "Mark D.",
      location: "Stonewood",
      rating: 5,
      text: "FBI contractor deploying to Frankfurt for CJIS system training. Needed a second passport since my primary was with the German consulate. Expedited second passport arrived in 8 days — just in time for the deployment briefing.",
      service: "Second Passport — Expedited",
    },
  ],
  facilities: [
    {
      id: "clarksburg-1",
      name: "Clarksburg Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 W Pike St",
      city: "Clarksburg",
      state: "WV",
      zip: "26301",
      phone: "(304) 623-1644",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Clarksburg — West Pike Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Clarksburg and Harrison County. Passport photos available on-site. Appointment required — limited afternoon hours, call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "clarksburg-2",
      name: "Harrison County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "301 W Main St, Room 211",
      city: "Clarksburg",
      state: "WV",
      zip: "26301",
      phone: "(304) 624-8640",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "Downtown Clarksburg — Harrison County Courthouse",
      website: "https://www.harrisoncountywv.com/circuit-clerk",
      websiteLabel: "Harrison County Clerk",
      notes: "County clerk passport acceptance counter in the Harrison County Courthouse. Often less crowded than the post office. No photo services on-site — obtain passport photos before visiting.",
      icon: "ri-government-line",
    },
    {
      id: "clarksburg-3",
      name: "Bridgeport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1200 W Main St",
      city: "Bridgeport",
      state: "WV",
      zip: "26330",
      phone: "(304) 842-6061",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Bridgeport — 5 miles east, Harrison County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Alternative facility in Bridgeport with more appointment availability. Convenient for Bridgeport, Anmoore, and eastern Harrison County residents. Photo services available.",
      icon: "ri-mail-line",
    },
    {
      id: "clarksburg-4",
      name: "Fairmont Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "331 Cleveland Ave",
      city: "Fairmont",
      state: "WV",
      zip: "26554",
      phone: "(304) 363-1756",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Fairmont — 18 miles north, Marion County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Alternative facility for northern Harrison County residents. Also convenient for FSU students and FBI CJIS employees who live in the Fairmont area. Photo services available.",
      icon: "ri-mail-line",
    },
    {
      id: "clarksburg-5",
      name: "Morgantown Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "215 High St",
      city: "Morgantown",
      state: "WV",
      zip: "26505",
      phone: "(304) 296-3670",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Morgantown — 35 miles north, Monongalia County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Largest facility in the region with most appointment availability. Convenient for Clarksburg residents who work or attend classes at WVU or connect through Morgantown Airport. Photo services available.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    { q: "How fast can I get a passport in Clarksburg?", a: "We offer Clarksburg-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. The nearest passport agency is in Detroit (350 miles) — making courier service the faster and far more practical option for North Central West Virginia residents." },
    { q: "Do I need to visit an office in Clarksburg?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Clarksburg Main Post Office or Harrison County Clerk), then ship documents overnight. We handle the State Department submission and return your passport to your Clarksburg address." },
    { q: "Which airport should Clarksburg travelers use?", a: "Two main options: Pittsburgh International Airport (PIT, ~105 miles north via I-79) for direct international flights, and North Central West Virginia Airport (CKB, ~8 miles east) for regional connections to DC and Chicago. Morgantown Municipal Airport (MGW, 35 miles) is another regional option." },
    { q: "Does the FBI CJIS facility affect passport processing?", a: "The FBI CJIS complex employs thousands of federal agents, analysts, and contractors — many of whom travel internationally for training, interagency meetings, and deployments. FBI travel authorizations often come with 7–14 days notice. We understand federal travel timelines and handle law enforcement and contractor passports with appropriate confidentiality and care." },
    { q: "What is the best price for expedited passport service in Clarksburg?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. Best price guarantee included." },
    { q: "Where can I get passport photos in Clarksburg?", a: "Walmart Supercenter on Emily Drive, Walgreens on West Main Street, CVS Pharmacy on West Pike Street, and the Clarksburg Main Post Office all offer passport photos. The UPS Store in Bridgeport (5 miles east) and Walgreens in Bridgeport also provide photo services." },
    { q: "Can I use Bridgeport or Fairmont acceptance facilities?", a: "Yes — many Clarksburg residents use the Bridgeport post office (5 miles east) or Fairmont post office (18 miles north) as acceptance facilities. These are fully valid options and often have more appointment availability than Clarksburg facilities." },
    { q: "What about FBI clearance vs. passport requirements?", a: "FBI CJIS employees and contractors: your security clearance and passport are managed separately. A valid security clearance does not replace or accelerate passport processing. FBI travel authorizations operate independently of passport readiness — maintain a current passport with at least 6 months validity so you're ready when deployment orders come." },
    { q: "How do FSU students from Clarksburg handle passports?", a: "Many Clarksburg-area students attend Fairmont State University (18 miles north). FSU study abroad acceptances arrive 6–8 weeks before departure. Start the passport process when you apply to a program — don't wait until acceptance. We provide student-specific guidance including checklists tailored to FSU programs." },
    { q: "How do I check my passport status from Clarksburg?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online status system. Processing from submission to return typically matches your chosen speed tier." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Emily Dr", address: "550 Emily Dr, Clarksburg, WV 26301", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
    { name: "Walgreens — W Main St", address: "300 W Main St, Clarksburg, WV 26301", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — W Pike St", address: "1000 W Pike St, Clarksburg, WV 26301", hours: "Daily 8 AM – 9 PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Clarksburg Main Post Office", address: "500 W Pike St, Clarksburg, WV 26301", hours: "Mon–Fri 9 AM – 3:30 PM", website: "https://tools.usps.com/find-location.htm", websiteLabel: "USPS Location" },
    { name: "The UPS Store — Bridgeport", address: "1240 W Main St, Bridgeport, WV 26330", hours: "Mon–Fri 8:30 AM – 6 PM, Sat 9 AM – 1 PM", website: "https://www.theupsstore.com/", websiteLabel: "UPS Store" },
  ],
  dmvLocations: [
    {
      name: "WV DMV — Bridgeport Regional Office",
      address: "105 Platinum Dr, Bridgeport, WV 26330",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, state ID cards. Located in Bridgeport near I-79. Appointment recommended.",
      featured: true,
    },
  ],
  dmvWebsite: "https://transportation.wv.gov/dmv/",
  dmvLabel: "West Virginia DMV — Official Website",
  airports: [
    {
      code: "PIT",
      name: "Pittsburgh International Airport",
      distance: "About 105 miles north of Clarksburg via I-79",
      address: "1000 Airport Blvd, Pittsburgh, PA 15231",
      note: "Primary international gateway for North Central West Virginia travelers. Direct flights to Cancun, Punta Cana, London, Frankfurt, and Caribbean destinations. About 1 hour 30 minutes via I-79.",
      flightUrl: "https://flypittsburgh.com/",
      flightLabel: "Pittsburgh Airport Website",
      featured: true,
    },
    {
      code: "CKB",
      name: "North Central West Virginia Airport",
      distance: "About 8 miles east of Clarksburg",
      address: "2000 Aviation Way, Bridgeport, WV 26330",
      note: "Regional airport with connections to Washington Dulles (IAD) and Chicago O'Hare (ORD) for international gateway access. About 15 minutes from downtown Clarksburg. Convenient for domestic connections.",
      flightUrl: "https://www.flyckb.com/",
      flightLabel: "CKB Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate — WV DHHR",
      desc: "Request certified birth certificates from the West Virginia DHHR Vital Registration Office.",
      url: "https://dhhr.wv.gov/bph/hsc/vital/Pages/default.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate — Harrison County",
      desc: "Request marriage license records from the Harrison County Clerk for name changes and passport applications.",
      url: "https://www.harrisoncountywv.com/county-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree — Harrison County",
      desc: "Obtain certified divorce records through the Harrison County Circuit Clerk for name change passport corrections.",
      url: "https://www.harrisoncountywv.com/circuit-clerk",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate — WV DHHR",
      desc: "Certified death certificates through WV DHHR for estate and legal matters.",
      url: "https://dhhr.wv.gov/bph/hsc/vital/Pages/default.aspx",
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Pittsburgh flight to Frankfurt in two days? FBI deployment with short notice? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Clarksburg residents renew fast — no agency visit required. Perfect for FBI CJIS employees, healthcare professionals, and Harrison County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport — First Time",
      description: "First-time applicants require an in-person acceptance visit. We guide Clarksburg residents through every step with clear instructions.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require DS-64 and additional documentation. We guide you through everything to avoid costly mistakes.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear checklists.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for FBI CJIS contractors and professionals.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Harrison County travelers through the process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "Wallet-size travel document for land and sea crossings to Canada, Mexico, Caribbean, and Bermuda.",
      bullets: ["Wallet-size convenience", "Land and sea travel", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Clarksburg WV", description: "Urgent passport processing for Clarksburg West Virginia travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Clarksburg WV", description: "Fast passport renewal for Clarksburg West Virginia residents." },
    { name: "First-Time Passport Clarksburg WV", description: "New passport application services for Clarksburg West Virginia residents." },
    { name: "Child Passport Clarksburg WV", description: "Minor passport services for Clarksburg West Virginia families." },
    { name: "Name Change Passport Clarksburg WV", description: "Passport name correction for Clarksburg residents." },
    { name: "Second Passport Clarksburg WV", description: "Second passport services for Clarksburg federal and frequent travelers." },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming FBI Clearance = Travel-Ready Documents",
      description: "FBI CJIS employees and contractors sometimes confuse their security clearance with passport readiness. A valid clearance does not guarantee passport validity. These are completely separate systems — you need both independently.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Underestimating Pittsburgh Airport Drive Time from Clarksburg",
      description: "PIT is 105 miles — about 1 hour 30 minutes via I-79 in good conditions. But I-79 fog in the Harrison County valleys during fall and winter, plus Pittsburgh tunnel traffic, can push it to 2+ hours. We build realistic drive times into every passport timeline.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Choosing CKB for International Travel Without Checking Connections",
      description: "North Central West Virginia Airport (CKB) is wonderfully convenient — only 8 miles away. But CKB is a regional airport serving domestic connections only. For international travel, budget extra connection time.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Photos from local pharmacies and big-box stores frequently fail State Department standards. We review all photos before submission to prevent rejection and delay.",
    },
    {
      icon: "ri-error-warning-line",
      title: "FBI Deployment Timeline Collapse",
      description: "FBI CJIS deployments and training assignments often come with 7–14 days notice — sometimes less. An expired passport during a deployment window is a critical failure. Federal employees: maintain a current passport at all times, independent of your agency's travel system.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order — just a few minutes from home or office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your departure airport — Pittsburgh, CKB, or Morgantown." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Clarksburg clients use the UPS Store in Bridgeport or ship from the Clarksburg post office." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency channel — faster than a Detroit agency appointment, no 350-mile drive required." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport arrives at your Clarksburg address within your selected timeframe. No long drive, no appointment scramble." },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned", "Daily status updates"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review", "No dedicated agent", "Updates only by mail", "Can't upgrade speed after submission"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — nearest is Detroit (350 miles)", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Detroit agency is 350 miles away. Booked 2+ weeks out", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 350-mile drive to Detroit", fpc: "Most Clarksburg travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission" },
    { feature: "Local Guidance", agency: "Generic — no Harrison County or FBI CJIS expertise", fpc: "Full Clarksburg/Harrison County/FBI CJIS knowledge" },
    { feature: "Cost vs Resellers", agency: "Government fees only — you handle all logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Fast passport services in Charleston, WV", route: "/charleston" },
    { name: "Expedited passport in Morgantown, WV", route: "/morgantown" },
    { name: "Quick passport services in Fairmont, WV", route: "/fairmont" },
    { name: "Urgent passport services in Pittsburgh, PA", route: "/pittsburgh" },
    { name: "West Virginia passport services overview", route: "/west-virginia" },
  ],
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeNote: "Fast Passport Center serves Clarksburg via secure registered courier with direct access to regional passport agencies. Our registered couriers hand-deliver your documents — meaning you get faster results without the 350-mile Detroit drive. Clarksburg residents can ship from any UPS Store, FedEx Office, or post office in Harrison County.",
  fpcOfficeDistance: "Serving Clarksburg, Bridgeport, Nutter Fort, Stonewood, Anmoore, Shinnston, and all Harrison County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Clarksburg and Harrison County. From downtown Clarksburg to Bridgeport, from Nutter Fort to Shinnston — we serve all Harrison County communities. Our courier service provides faster processing than a Detroit agency appointment.",
  nearbyCitiesIntro: "We serve Clarksburg and all Harrison County communities including Bridgeport, Nutter Fort, Stonewood, Anmoore, Shinnston, Salem, and Lost Creek. We also serve nearby communities in Marion County (Fairmont) and Monongalia County (Morgantown). Travelers depart from Pittsburgh International and North Central West Virginia airports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Clarksburg as simple and predictable as possible. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you.",
  mistakesIntro: "Clarksburg travelers encounter unique passport issues — from FBI clearance confusion to Pittsburgh airport timing to deployment timeline crunches. Here are the most common mistakes we see.",
  testimonialsIntro: "Clarksburg travelers — from FBI CJIS professionals and United Hospital Center staff to Harrison County families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Clarksburg, WV? Here are the most common ones from North Central West Virginia travelers.",
  statePageRoute: "/states/west-virginia",
  statePageName: "West Virginia",
  servicesIntro: "Whether you need a renewal before a Pittsburgh flight to Frankfurt, an emergency passport for an FBI deployment, or a first-time passport for an FSU study abroad — Fast Passport Center handles it with reserved courier submission. As a registered State Department courier, we guarantee the best price.",
  travelTiming: {
    title: "Travel & Passport Timing for Clarksburg Residents",
    intro: "Clarksburg's position on the I-79 corridor with proximity to FBI CJIS and multiple airports creates distinct travel patterns.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "PIT — Pittsburgh International Airport",
        subtitle: "105 miles north via I-79, primary international gateway",
        description: "Pittsburgh International serves as the primary international gateway for Clarksburg travelers with direct flights to Cancun, Punta Cana, London, and Frankfurt. The I-79 drive takes about 1 hour 30 minutes in good conditions — but factor in 2+ hours for Pittsburgh tunnel traffic during peak times.",
        tip: "For early morning international flights, I-79 is typically clear. For afternoon departures, budget extra time for Pittsburgh bridge and tunnel traffic — especially on Fridays and on Steelers home game days.",
      },
      {
        icon: "ri-shield-check-line",
        title: "FBI CJIS Deployment & Training Travel",
        subtitle: "Short-notice federal and contractor international trips",
        description: "Clarksburg's FBI CJIS complex — the largest FBI division outside DC — generates steady short-notice international travel for cybersecurity conferences, interagency meetings, and contractor training deployments. Travel authorizations often arrive 7–14 days before departure.",
        tip: "FBI employees and contractors: your security clearance and passport are completely separate. Maintain a current passport independently — when deployment orders come, there's no time for standard processing. Consider a second passport if you frequently travel internationally for work.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "I-79 Corridor = Pittsburgh Access, Detroit Distance",
      description: "Clarksburg's I-79 location means easy access to Pittsburgh International Airport (105 miles) but significant distance to the nearest passport agency (Detroit, 350 miles). Our courier service bridges this gap — faster processing without the drive.",
    },
  },
  destinations: {
    title: "Where Clarksburg Travelers Go",
    intro: "Clarksburg's FBI CJIS presence, healthcare hub status, and I-79 corridor location create distinct international travel patterns.",
    stats: [
      { stat: "40%", label: "of Clarksburg expedited requests are federal or contractor-related" },
      { stat: "1–2 Weeks", label: "average lead time for FBI and federal contractor travel" },
      { stat: "PIT", label: "dominant airport for 85%+ of Clarksburg international departures" },
      { stat: "6 Days", label: "shortest turnaround for an FBI CJIS analyst deploying to London" },
    ],
    destinations: [
      { name: "United Kingdom", context: "FBI cybersecurity conferences, PIT-London seasonal direct", urgency: "Federal travel authorizations 7–14 days before departure", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "PIT-Frankfurt direct, CJIS system training, contractor supplier meetings", urgency: "Training dates fixed and often short-notice", icon: "ri-map-pin-2-line" },
      { name: "Spain & Italy", context: "United Hospital Center medical conferences, FSU study abroad", urgency: "Conference dates fixed 6–12 weeks in advance", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "PIT direct flights, family resort vacations, winter getaways", urgency: "Vacation bookings peak January–March", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "FBI interagency meetings, healthcare professional conferences", urgency: "Meeting dates often 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "CJIS technology exchanges, cybersecurity collaborations", urgency: "Federal travel authorizations typically 10–14 days notice", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other West Virginia Service Areas",
    crossLinksDesc: "We serve travelers across the Mountain State.",
    crossLinks: [
      { name: "Charleston", route: "/charleston" },
      { name: "Huntington", route: "/huntington" },
    ],
  },
};